import { createFileRoute } from "@tanstack/react-router";

const ClientProjectsRoute = (): null => null;

export const Route = createFileRoute("/_app/settings/clients/$id/projects/")({
	component: ClientProjectsRoute,
});
